export default __webpack_public_path__ + "static/media/1695.d67eec78.png";